import { useTunnels } from "../../context/tunnels";

/**
 * Renders app-level controls into the bottom-right footer, beside the help
 * button.
 *
 * A tunnel rather than editing Footer.tsx directly: consumers put things here
 * that depend on their own state (auth, network), and this package is
 * publishable and must not import any of that. Mirrors FooterCenter.
 */
const FooterRight = ({ children }: { children?: React.ReactNode }) => {
  const { FooterRightTunnel } = useTunnels();

  return <FooterRightTunnel.In>{children}</FooterRightTunnel.In>;
};

export default FooterRight;
FooterRight.displayName = "FooterRight";
